



























































import { UseModal } from "@/components/root/modal";
import InformationLabelsModalVue from "@/views/customize/information/information-labels/InformationLabelsModal.vue";
import { state } from "../data/state";
import { CountItem } from "../data/model";
import Vue from "vue";
import DashboardCard from "../DashboardCard.vue";
import { computed } from "@vue/composition-api";
import { cord } from "@/gql/lib";
import { AxisType } from "@/gql/types";
import MIPModalVue from "@/views/customize/mip/MIPModal.vue";
import WhatDashboardModalVue from "@/views/overview/sources/ms-365-activities/mapping/what/WhatDashboardModal.vue";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { InformationType } from "@/common/models";
import { SharedState } from "@/common/state";
import InfoTypeCountsModalVue from "@/components/modals/info-types-counts-modal/InfoTypeCountsModal.vue";
import { InfoTypesCountModalProps } from "@/components/modals/info-types-counts-modal/model";
export default Vue.extend({
  props: ["source"],
  components: { DashboardCard, /* Spinner, */ SkeletonLoaderItem },
  setup(props) {
    const { is_loading_all, events_counts_for_l0 } = state;
    const show_manage_labels_modal = () => {
      if (
        SharedState.restrictions.is_restricted_app("info_type_customization")
      ) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "information customization"
        );
        return;
      }
      UseModal().show(InformationLabelsModalVue);
    };

    const max_value = computed(() => {
      return Math.max(...events_counts_for_l0.value.map((d) => d.count));
    });

    const playbook_desc = computed(() => {
      if (props.source && props.source == "google_workspace") {
        return "";
      } else {
        return `Automate <b>MPIP</b> Sensitivity Labels on Microsoft 365 Information In motion`;
      }
    });

    const open_mip_modal = async () => {
      SharedState.ifUserEnabledFeature(
        "auto_mip_labeling",
        async () => {
          await UseModal().show(MIPModalVue);
        },
        { premium_modal_key: "automatemicrosoftlabeling-popup-2024" }
      );
    };

    const show_what_dashboard = async () => {
      await UseModal().show(WhatDashboardModalVue);
    };

    const show_l1s = async (item: CountItem) => {
      const { type, from } = SharedState.selectedTimeFrameOption.value;
      const label = SharedState.allInfoTypes.value[item.id];
      if (SharedState.restrictions.is_restricted_info(label.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "info",
          label.labelName
        );
        return;
      }
      const l1s = (SharedState.typesByCategories.value.get(
        item.id
      ) as InformationType[]).map((d) => d.id);

      const modalProps: InfoTypesCountModalProps = {
        title: `<b>${label.name}</b>`,
        files_title: `<b>${label.name}</b> Files`,
        info_type: label.id,
        coordinate: {
          x: cord(AxisType.None, []),
          y: {
            type: AxisType.ContentLabel,
            values: [label.id, ...l1s],
          },
          z: {
            type,
            values: [from],
          },
        },
        events: {
          title: (entity, info_type_id) => {
            return `Events involving <b>${entity.name}</b> information`;
          },
          coordinate: (entity, info_type_id) => {
            return {
              x: cord(AxisType.None, []),
              y: {
                type: AxisType.ContentLabel,
                values: [entity.id],
              },
              z: {
                type,
                values: [from],
              },
            };
          },
        },
      };
      await UseModal().show(InfoTypeCountsModalVue, modalProps);
    };

    return {
      playbook_desc,
      show_manage_labels_modal,
      events_counts_for_l0,
      is_loading_all,
      max_value,
      show_l1s,
      open_mip_modal,
      show_what_dashboard,
    };
  },
});
